import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lui-norway-logo',
    imports: [CommonModule],
    templateUrl: './norway-logo.component.html',
    styleUrls: ['./norway-logo.component.scss']
})
export class NorwayLogoComponent {}
